module.exports = __webpack_public_path__ + "static/media/Maven_3132.9ad7bc48.jpg";